var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"page-breadcrumb"},[_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","sm":"12"}},[_c('v-toolbar',{staticClass:"transparent mb-1",attrs:{"dense":"","flat":"","height":"40"}},[_c('v-toolbar-title',[_c('span',{staticClass:"info--text"},[_vm._v(_vm._s(_vm.$t(_vm.title)))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }